import React from "react";
import PropTypes from "prop-types";
import IconButton from "components/icon-button";
import ProfileUsername from "./partial/profile-username";
import ProfilePhoto from "./partial/profile-photo";
import Icon from "components/icon";
import { isMobileOnly } from "react-device-detect";

const ProfileInfo = ({ onClick, text }) => (
  <IconButton onClick={onClick} color="inherit">
    <ProfilePhoto />
    {!isMobileOnly && (
      <>
        <ProfileUsername>{text}</ProfileUsername>
        <Icon name="keyboard-arrow-down" />
      </>
    )}
  </IconButton>
);

ProfileInfo.propTypes = {
  /**
   * Texto del perfil del usuario
   */
  text: PropTypes.string,
  /**
   * Callback que se ejecuta al hacer clic en el icono del perfil
   */
  onClick: PropTypes.func,
};

export default ProfileInfo;
